import { encodeFavicon } from './skin-assets';

// Espelha o setAttribute('href', ...) do login-page: sem valor cru, mantém o
// favicon atual do documento; sem o elemento #favicon, é um no-op silencioso.
export function applyFavicon(faviconRaw: string | null): void {
  if (!faviconRaw) {
    return;
  }

  const link = document.getElementById('favicon');
  if (!link) {
    return;
  }

  link.setAttribute('href', encodeFavicon(faviconRaw));
}
